const component = "site-section-active-filters";

export const siteSectionActiveFilters = {
  component,
  text: `${component}/text`,
  filterItem: {
    item: `${component}/filter-item`,
    label: `${component}/label`,
    deleteButton: `${component}/delete-button`,
  },
};
